import React from 'react';
import PropTypes from 'prop-types';
import { withApollo } from 'react-apollo';
import DietSettingsValidateQuery from './DietSettingsValidateQuery';

class DietSettingsValidateDataConnectorApollo extends React.Component {
    static propTypes = {
        children: PropTypes.func.isRequired,
        client: PropTypes.shape({
            query: PropTypes.func.isRequired,
        }).isRequired,
    };

    fetch = async request => {
        const result = await this.props.client.query({
            query: DietSettingsValidateQuery,
            variables: {
                request,
            },
            fetchPolicy: 'no-cache',
        });

        return result;
    };

    render() {
        const { children } = this.props;

        return children({
            validateData: request => this.fetch(request),
        });
    }
}

export default withApollo(DietSettingsValidateDataConnectorApollo);
